/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Read_Along_Ai_First_WordsInputs */

const en_read_along_ai_first_words = /** @type {(inputs: Read_Along_Ai_First_WordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`First ${i?.count} words`)
};

const es_read_along_ai_first_words = /** @type {(inputs: Read_Along_Ai_First_WordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Primeras ${i?.count} palabras`)
};

/**
* | output |
* | --- |
* | "First {count} words" |
*
* @param {Read_Along_Ai_First_WordsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_first_words = /** @type {((inputs: Read_Along_Ai_First_WordsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_First_WordsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_first_words(inputs)
	return en_read_along_ai_first_words(inputs)
});